export default {
    state: {
        // 应用内所有待办
        taskCount: {}
    },
    getters: {
        // 应用内 知会未读+待审批
        allCount: (state) => state.taskCount.allCount,
        // 知会未读
        notifyCount: (state) => state.taskCount.notify,
        // 待审批
        taskCount: (state) => state.taskCount.task,
        // 待审批
        tabNotifyCount: (state) => state.taskCount.tabNotify
    },
    mutations: {
        updateTaskCount (state, taskCount) {
            state.taskCount = taskCount;
        }
    },
    actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/notification.js